module.exports = __webpack_public_path__ + "img/qr-code-interactive.2288a641.svg";